import { toast } from 'react-toastify';

export default {
  info: (message: string) => toast.info(message),
  error: (message: string) => toast.error(message),
};
